import TopMenu from "../../TopMenu";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { get } from "../../../../utils/api";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import TableDocument from "../../TableDocument";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import ViewDetailsDrawer from "../../ViewDetailsDrawer";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";

const Main = () => {
  const { user } = useUser();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("/naturalGasApporvalList");
  const [approvalUrl, setApprovalUrl] = useState(
    "/stationaryCombustion/naturalGasApporveOrReject"
  );
  const columnWidth = user?.companyAdmin
    ? "12% 15% 15% 15% 15% 17% 8%"
    : "12% 18% 20% 18% 18% 8%";
  const toggleData = [
    {
      title: "Natural Gas",
      url: "/naturalGasApporvalList",
      approvalUrl: "/stationaryCombustion/naturalGasApporveOrReject",
    },
    {
      title: "Coal",
      url: "/coalApprovalList",
      approvalUrl: "/stationaryCombustion/coalApporveOrRejectRequest",
    },
    {
      title: "Petroleum / Gasoline",
      url: "/petrolApprovalList",
      approvalUrl: "/stationaryCombustion/petrolApporveOrReject",
    },
    {
      title: "Diesel",
      url: "/dieselApporvalList",
      approvalUrl: "/stationaryCombustion/dieselApporveOrRejectRequest",
    },
    {
      title: "Fuel Oil",
      url: "/fuelOilApprovalList",
      approvalUrl: "/stationaryCombustion/fuelOilApproveOrReject",
    },
    {
      title: "LPG",
      url: "/lpgApprovalList",
      approvalUrl: "/stationaryCombustion/lpgApporveOrReject",
    },
    {
      title: "Propane",
      url: "/propaneApprovalList",
      approvalUrl: "/stationaryCombustion/propaneApporveOrReject",
    },
  ];

  const headers = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      key: "typeOfEntry",
      title: "Type Of Entry",
    },
    // {
    //   title: "Industrial Process",
    //   key: "industrialProcess",
    //   field: "industryProcess",
    // },
    // {
    //   title: "Equipment Type",
    //   key: "equipmentType",
    // }

    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);
  const viewheaders = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "industrialEquipmentName", title: "Industrial Equipment" },
    { key: "equipmentTypeName", title: "Equipment Type" },
    { key: "typeOfEntry", title: "Type of Entry" },
    { key: "quantityConsumed", title: "Quantity Consumed" },
    { key: "calorificValue", title: "Calorific Value" },
    { key: "hours", title: "Used Hours" },
    { key: "remarks", title: "Remarks" },
  ];
  const viewcolumnWidth = `repeat(${
    viewheaders.length + 1
  }, minmax(180px, 1fr))`; // +1 for action

  const [data, setData] = useState([]);
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Equipment Type": false,
    Equipment: false,
  });
  const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    equipmentType: [],
    industrialEquipment: [],
  });
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [searchQuery, setSearchQuery] = useState("");

  const filters = ["Date", "Equipment Type", "Equipment"];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/stationaryCombustion${url}`);
      const data = response.data.data;

      const uniqueEquipmentType = [
        ...new Set(
          data.map((el) => el.equipmentType?.name).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueIndustrialEquipment = [
        ...new Set(
          data.map((el) => el.industrialEquipment?.name).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        equipmentType: uniqueEquipmentType,
        industrialEquipment: uniqueIndustrialEquipment,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: rowsPerPage,
        search: searchQuery,
      }).toString();
      // const response = await get(
      //   `/stationaryCombustion${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      // );
      const response = await get(`/stationaryCombustion${url}?${queryParams}`);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, searchQuery, url, fromDate, toDate, selectedFacility]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const fetchDataCallback = async () => {
    await fetchData();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    ...Object.keys(selectedFields).reduce((acc, key) => {
      const selectedOptions = selectedFields[key];

      // Check if there are selected options
      if (selectedOptions && selectedOptions.length > 0) {
        // Join options into a string or keep them as an array
        acc[key] = selectedOptions.join(","); // Change to an array if needed
      }
      return acc;
    }, {}),
  };

  const handleToggle = (option, url, approvalUrl) => {
    setSelectedOption(option);
    setUrl(url);
    setApprovalUrl(approvalUrl);
    setSearchQuery("");
    setIsFiltersApplied(false);
    setAppliedFilters({});
    setSelectedFilter("Date");
    setSelectedMonth(currentMonth + 1);
    setSelectedYear(currentYear);
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0]?.title);
  }, []);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <>
        <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
        <TopMenu
          {...{
            setDrawerFilterOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFiltersApplied,
            toggleData,
            searchQuery,
            setSearchQuery,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Stationary Combustion"}
        />
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <TableDocument
            {...{
              data,
              totalPages,
              headers,
              page,
              handleChangePage,
              columnWidth,
              isShortContent,
              tableContainerRef,
            }}
            setsnackOpen={setsnackOpen}
            fetchDataCallback={fetchDataCallback}
            apiUrl={approvalUrl}
            viewcolumnWidth={viewcolumnWidth}
            viewheaders={viewheaders}
            viewPage={ViewDetailsDrawer}
          />
        </Box>
      </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default Main;
